import type {
  PublishJob,
  PublishPayload,
  PublishTarget
} from '@utils/types/publishing/publish.ts';

/** View the publish dialog is rendering. */
export type PublishView =
  | 'choose-connection'
  | 'choose-target'
  | 'choose-payload'
  | 'confirm'
  | 'in-flight';

export interface DialogState {
  view: PublishView;
  connectionId: string | null;
  target: PublishTarget | null;
  /** Agenda item id when iBabs. */
  agendaItemId: string | null;
  payload: PublishPayload;
  /** Set once a job is in flight (new or resumed). */
  activeJob: PublishJob | null;
}

export function buildInitialState(
  defaultPayloadKind: 'captions' | 'transcript',
  availableCaptionLanguages: string[]
): DialogState {
  return {
    view: 'choose-connection',
    connectionId: null,
    target: null,
    agendaItemId: null,
    payload:
      defaultPayloadKind === 'captions'
        ? { kind: 'captions', languages: availableCaptionLanguages.slice(0, 2) }
        : { kind: 'transcript', format: 'docx' },
    activeJob: null
  };
}
